@if (isVisible) {
	<div
		class="sensor-element"
		[class.drag]="canMove"
		[class.selected]="selected"
		[cdkDragDisabled]="!canMove"
		cdkDrag
	>
		@if (canMove) {
			<div class="drag-icon-container">
				<mat-icon
					class="drag-icon"
					[ngClass]="selected ? 'light-accent' : 'secondary-text-icon'"
					cdkDragHandle
				>
					drag_indicator
				</mat-icon>
			</div>
		}
		<div class="content mobile" (click)="onChooseAsset()">
			<div class="content-wrapper">
				<mat-icon
					class="accent-icon vertical-centering sensor-icon"
					[ngClass]="selected ? 'light-accent' : 'accent-icon'"
					[svgIcon]="icon"
				></mat-icon>
				<span class="sensor-name">{{ asset?.name }}</span>
				<mat-checkbox
					disableRipple
					color="primary"
					class="au-checkbox vertical-centering sensor-checkbox"
					[class.selected]="isSelectable"
					(change)="onSelectAsset()"
					(click)="$event.stopPropagation()"
				>
				</mat-checkbox>
				@if (canDelete) {
					<mat-icon matRipple class="close-icon vertical-centering" (click)="onDelete()">
						close
					</mat-icon>
				}
			</div>
		</div>
		<div class="content desktop" (click)="onChooseAsset()" (dblclick)="onSelectAsset()">
			<div class="content-wrapper">
				<mat-icon
					class="accent-icon sensor-icon"
					[ngClass]="selected ? 'light-accent' : 'accent-icon'"
					[svgIcon]="icon"
				></mat-icon>
				<span class="sensor-name">{{ asset?.name }}</span>
				<mat-checkbox
					disableRipple
					color="primary"
					class="au-checkbox sensor-checkbox"
					[class.none]="isSelectable"
				>
				</mat-checkbox>
				@if (canDelete) {
					<mat-icon matRipple class="close-icon" (click)="onDelete()"> close </mat-icon>
				}
			</div>
		</div>
	</div>
}
